import { render } from "./FloatingActionBut.vue?vue&type=template&id=013ec713&scoped=true"
import script from "./FloatingActionBut.vue?vue&type=script&lang=js"
export * from "./FloatingActionBut.vue?vue&type=script&lang=js"

import "./FloatingActionBut.vue?vue&type=style&index=0&id=013ec713&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src618844026/src/meta-page-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013ec713"]])

export default __exports__